import gql from "graphql-tag";

export const CREAR_PACIENTE = gql`
  mutation crearPaciente(
    $dni: String!
    $nombre: String!
    $primer_apellido: String!
    $segundo_apellido: String
    $email: String
    $telefono: String
    $enfermedades: [Int]
    $fecha_nacimiento: String
    $sexo: String
    $nivel_instruccion: Int
    $fecha_diagnostico: String
    $domicilio: DomicilioInput
  ) {
    createPaciente(
      input: {
        dni: $dni
        nombre: $nombre
        primer_apellido: $primer_apellido
        segundo_apellido: $segundo_apellido
        email: $email
        telefono: $telefono
        enfermedades: $enfermedades
        fecha_nacimiento: $fecha_nacimiento
        sexo: $sexo
        nivel_instruccion: $nivel_instruccion
        fecha_diagnostico: $fecha_diagnostico
        domicilio: $domicilio
      }
    ) {
      dni
      file
      alreadyExists
      alreadyExistsAsOther
      temporaryPassword
    }
  }
`;

export const ASIGNAR_PACIENTE = gql`
  mutation asignarPaciente($id_medico: Int!, $dni_paciente: String!) {
    asignarPaciente(id_medico: $id_medico, dni_paciente: $dni_paciente) {
      id
    }
  }
`;

export const ACEPTAR_CONDICIONES = gql`
  mutation aceptarCondiciones($id_paciente: Int!) {
    aceptarCondiciones(id_paciente: $id_paciente) {
      dni
    }
  }
`;

export const REGENERAR_CLAVES = gql`
  mutation regenerarCredenciales($id_medico: Int, $id_paciente: Int) {
    regenerarCredenciales(id_medico: $id_medico, id_paciente: $id_paciente) {
      file
    }
  }
`;

export const CREAR_ENCUESTA = gql`
  mutation crearEncuesta(
    $id_tipo_encuesta: Int!
    $id_medico: Int!
    $id_paciente: Int!
  ) {
    createEncuesta(
      id_tipo_encuesta: $id_tipo_encuesta
      id_medico: $id_medico
      id_paciente: $id_paciente
    ) {
      id
      estado_encuesta {
        nombre
        descripcion
      }
      tipo_encuesta {
        tipo
      }
    }
  }
`;
